import { GenericFieldConfig } from '../../../../components/common/GenericFormTab';

export const InstallInstallationFieldConfigs: GenericFieldConfig[] = [
  { label: 'Well name', name: 'Well', type: 'select', options: [], required: true },
  { label: 'Lift type', name: 'LiftType', type: 'select', options: [], required: true },
  { label: 'Manufacturer', name: 'Manufacturer', type: 'select', options: [] },
  { label: 'Manufacturer controller', name: 'ManufacturerController', type: 'select', options: [] },
  { label: 'Install no.', name: 'InstallNumber', type: 'text', readOnly: true },
  {
    label: 'Status',
    name: 'Status',
    type: 'select',
    options: [
      { key: 'Failed', value: 'Failed' },
      { key: 'Pulled NF', value: 'Pulled NF' },
      { key: 'Failed < 90 Days', value: 'Failed < 90 Days' },
    ],
    disabled: true,
  },
  {
    label: 'Installation report',
    name: 'InstallReportDocuments',
    type: 'file',
    placeholderOptionLabel: 'Upload new installation report',
    multiple: true,
    singleField: true,
    rowFullFlex: true,
  },
  {
    label: 'Pull report (imported)',
    name: 'PullReportDocuments',
    type: 'file',
    placeholderOptionLabel: 'Upload new pull report',
    multiple: true,
    singleField: true,
    rowFullFlex: true,
  },
  {
    label: 'RCFA report (imported)',
    name: 'RcfaReportDocuments',
    type: 'file',
    placeholderOptionLabel: 'Upload new RCFA report',
    multiple: true,
    singleField: true,
    rowFullFlex: true,
  },
  { label: 'Purchased system', name: 'IsPurchasedSystem', type: 'checkbox', singleField: true },
  { label: 'Used system', name: 'IsUsedSystem', type: 'checkbox', singleField: true },
  { label: 'Exclude from reports', name: 'IsExcluded', type: 'checkbox', singleField: true },
];

export const RunlifeFieldConfigs: GenericFieldConfig[] = [
  { label: 'Install date', name: 'InstallDateString', type: 'date', required: true },
  { label: 'Start date', name: 'StartDateString', type: 'date' },
  { label: 'Fail date', name: 'FailDateString', type: 'date' },
  { label: 'Pull date', name: 'PullDateString', type: 'date' },
  { label: 'Teardown date', name: 'TeardownDateString', type: 'date' },
  { label: 'Runlife days', name: 'RunlifeDays', type: 'number', readOnly: true },
];

export const CompletionFieldConfigs: GenericFieldConfig[] = [
  { label: 'Pump intake depth (MD)', name: 'PumpIntakeDepthMd', type: 'number', showNumberAsFixed2: true },
  { label: 'Pump intake depth (TVD)', name: 'PumpIntakeDepthTvd', type: 'number', showNumberAsFixed2: true },
  { label: 'Top perf', name: 'TopPerf', type: 'number', showNumberAsFixed2: true },
  { label: 'Bottom perf', name: 'BottomPerf', type: 'number', showNumberAsFixed2: true },
  { label: 'Tubing size', name: 'TubingSize', type: 'number', showNumberAsFixed2: true },
  {
    label: 'Completion diagram',
    name: 'CompletionDiagramDocuments',
    placeholderOptionLabel: 'Upload new completion diagram',
    type: 'file',
    multiple: true,
    singleField: true,
    rowFullFlex: true,
  },
];

export const SystemDesignFieldConfigs: GenericFieldConfig[] = [
  { label: 'Design date', name: 'DesignDate', type: 'date' },
  { label: 'Fluid above pump', name: 'FluidAbovePump', type: 'number', showNumberAsFixed2: true },
  { label: 'Tubing head pressure', name: 'TubingHeadPressure', type: 'number', showNumberAsFixed2: true },
  { label: 'Future static BHP', name: 'FutureStaticBhp', type: 'number', showNumberAsFixed2: true },
  { label: 'Specific gravity water', name: 'SpecificGravityWater', type: 'number', showNumberAsFixed2: true },
  { label: 'Production GOR', name: 'ProductionGor', type: 'number', showNumberAsFixed2: true },
  { label: 'Future water cut (%)', name: 'FutureWaterCutPercent', type: 'number', showNumberAsFixed2: true },
  { label: 'CO2 concentration', name: 'Co2Concentration', type: 'number', showNumberAsFixed2: true },
  { label: 'Reservoir temperature', name: 'ReservoirTemperature', type: 'number', showNumberAsFixed2: true },
  {
    label: 'Design data sheet',
    name: 'DesignDataSheetDocuments',
    type: 'file',
    placeholderOptionLabel: 'Upload new design data sheet',
    multiple: true,
    singleField: true,
    rowFullFlex: true,
  },
  {
    label: 'Vendor design',
    name: 'VendorDesignDocuments',
    type: 'file',
    placeholderOptionLabel: 'Upload new vendor design',
    multiple: true,
    singleField: true,
    rowFullFlex: true,
  },
  {
    label: 'Vendor quote',
    name: 'VendorQuoteDocuments',
    type: 'file',
    placeholderOptionLabel: 'Upload new vendor quote',
    multiple: true,
    singleField: true,
    rowFullFlex: true,
  },
];

export const FailureFieldConfigs: { failure: GenericFieldConfig[] } = {
  failure: [
    { label: 'Reason for pull', name: 'ReasonForPull', type: 'select' },
    { label: 'Reason for pull detail', name: 'ReasonForPullDetail', type: 'text' },
    { label: 'Failed component', name: 'Component', type: 'select' },
    { label: 'Failed sub component', name: 'Subcomponent', type: 'select' },
    { label: 'Indirect failure', name: 'InDirectFailure', type: 'checkbox' },
    { label: 'Failure description', name: 'FailureDescription', type: 'text' },
    { label: 'Failure cause', name: 'FailureCause', type: 'select' },
    { label: 'Failure cause (detail)', name: 'FailureCauseDetail', type: 'select' },
    { label: 'Failure cause (specific)', name: 'FailureCauseSpecific', type: 'text' },
    { label: 'Corrective action', name: 'FailureCorrectiveAction', type: 'text' },
    { label: 'Further investigation', name: 'FurtherInvestigation', type: 'text' },
    { label: 'Operating comments', name: 'OperatingComments', type: 'text' },
    { label: 'Observations', name: 'Observations', type: 'checkbox' },
  ],
};

export const InstallationCostFieldConfig: GenericFieldConfig[] = [
  { label: 'Workover cost ($)', name: 'WorkoverCost', type: 'number', showNumberAsFixed2: true },
  { label: 'Runlife (days)', name: 'RunlifeDays', type: 'number', readOnly: true },
  { label: 'Daily cost ($)', name: 'DailyCost', type: 'number', showNumberAsFixed2: true },
  { label: 'Monthly rental ($)', name: 'MonthlyCost', type: 'number', readOnly: true, showNumberAsFixed2: true },
  { label: 'Transfer of ownership date', name: 'TransferOwnershipDate', type: 'date' },
  { label: 'Total rental cost ($)', name: 'RentalCost', type: 'number', readOnly: true, showNumberAsFixed2: true },
  { label: 'Repair cost ($)', name: 'RepairCost', type: 'number', showNumberAsFixed2: true },
  { label: 'Total cost ($)', name: 'TotalCost', type: 'number', readOnly: true, showNumberAsFixed2: true },
  { label: 'AFE number', name: 'AfeNumber', type: 'number' },
];
